var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.items),function(item,index){return [(item.type === 'divider')?_c('div',{key:`divider${index}`,staticClass:"divider"}):_c('EditorMenuItem',_vm._b({key:index},'EditorMenuItem',item,false))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }